import React, { useContext, useState } from 'react'
import styles from '../../styles'
import { makeStyles } from '@material-ui/core/styles'
import MediaQuery, { useMediaQuery } from 'react-responsive'
import EnhancedMenuLargeScreen from './MenuLargeScreen'
import './styles.css'
import { useHistory } from 'react-router-dom'
import EnhancedMenuBurger from './MenuBurger'
import classNames from 'classnames'
import { ClassValue } from 'classnames/types'
import { IntlConfig } from 'react-intl'
import NotesIcon from '@material-ui/icons/Notes'
import CloseIcon from '@material-ui/icons/Close'
import { LangContext } from '../langContext/langContext'
import portals from '../../enums/portalsEnum'
import links from '../../enums/linksEnum'
import languages from '../../enums/languagesEnum'

const useStyles = makeStyles(theme => ({
	...styles(theme),
	menuStyle: {
		width: '100%',
		display: 'flex',
		zIndex: 1101,
		position: 'fixed',

		'& #logo': {
			cursor: 'pointer'
		}
	},
	menuLargeStyle: {
		height: '100px',

		'& #logo': {
			margin: '24px 40px 0',
			width: '150px'
		}
	},
	menuSmallStyle: {
		height: '65px',
		borderBottom: '1px solid ' + theme.palette.blue['10'],

		'& #logo': {
			margin: '20px 15px 0',
			width: '110px'
		}
	},
	menuHover: {
		'&:hover': {
			color: theme.palette.dynamic.main
		}
	},
	menuSmallScreenStyle: {
		display: 'flex',
		alignItems: 'center',
		paddingRight: 0,

		'& div': {
			alignItems: 'center',
			height: '100%',
			cursor: 'pointer',
			display: 'flex',
		},
		'& div:first-child': {
			paddingRight: 20,
		},
		'& div:last-child': {
			width: '120px',
			paddingLeft: 20,
			borderLeft: '1px solid ' + theme.palette.blue['10'],
		},
		'& svg': {
			fontSize: '30px',
			marginLeft: '12px',
			marginRight: '24px'
		}
	},
	selected: {
		color: theme.palette.dynamic.main,

		'&::after': {
			bottom: '0',
			width: '100%',
			height: '2px',
			content: '\' \'',
			display: 'inline-block',
			background: theme.palette.dynamic.main,
			position: 'absolute',
			right: '0'
		}
	},
	selectedLang: {
		color: theme.palette.blue.main + ' !important'
	},
	langStyle: {
		whiteSpace: 'nowrap',

		'& span': {
			cursor: 'pointer',
			color: theme.palette.blue['30'],
			textTransform: 'uppercase'
		},
		'& span:first-child': {
			marginRight: '5px'
		},
		'& span:last-child': {
			marginLeft: '5px'
		}
	}
}))

interface AcceptingProps {
	intl: IntlConfig
}

type MenuProps = AcceptingProps

const Menu: React.FC<MenuProps> = (
	{
		intl
	}
) => {
	const classes = useStyles()
	const history = useHistory()
	const { switchLang } = useContext(LangContext)
	const isLargeScreen = useMediaQuery(
		{
			query: '(min-width: 1025px)'
		}
	)
	const [open, setOpen] = useState<boolean>(false)

	const menuClass: ClassValue = classNames(
		{
			[classes.menuLargeStyle]: isLargeScreen,
			[classes.menuSmallStyle]: !isLargeScreen
		},
		classes.backgroundWhite,
		classes.colorBlue,
		classes.menuStyle
	)

	const menuSmallScreenClass: ClassValue = classNames(
		'col-xs-10 end-xs',
		classes.menuSmallScreenStyle,
		classes.text3
	)

	const langClass: ClassValue = classNames(
		classes.text4,
		classes.langStyle
	)

	const redirectTo = (link: string) => {
		setOpen(false)
		history.push(link)
	}

	const linkIsSelected = (linksArray: string[], link: string) => {
		return linksArray.includes(link) ?
			classNames(
				{
					[classes.selected]: isLargeScreen,
					[classes.colorDynamic]: !isLargeScreen
				}
			) : ''
	}

	return (
		<>
			<div
				className={menuClass}
			>
				<div className="col-xs-2">
					<img
						src={process.env.REACT_APP_TARGET === portals.residence ? 'img/youFirst.jpg' : 'img/youFirstCampus.svg'}
						alt="Logo Youfirst"
						id="logo"
						onClick={() => redirectTo(links.dashboard)}
					/>
				</div>

				<MediaQuery
					maxWidth={1024}
				>
					{
						(match) => {
							return match ? (
								<>
									<div className={menuSmallScreenClass}>
										<div>
											<span className={langClass}>
												{
													Object.keys(languages).map(
														(language, index) => (
															<React.Fragment key={index}>
																<span
																	onClick={() => switchLang(language)}
																	className={intl.locale === language ? classes.selectedLang : ''}
																>
																	{language}
																</span>
																{index < Object.keys(languages).length - 1 ? '|' : ''}
															</React.Fragment>
														)
													)
												}
											</span>
										</div>
										<div onClick={() => setOpen(!open)}>
											{
												open &&
												<>
													<span>Fermer</span>
													<CloseIcon />
												</>
											}
											{
												!open &&
												<>
													<span>Menu</span>
													<NotesIcon />
												</>
											}
										</div>
									</div>

								</>
							) : (
								<>
									<EnhancedMenuLargeScreen
										onClick={redirectTo}
										locale={intl.locale}
										changeLang={(ln: string) => switchLang(ln)}
										linkIsSelected={linkIsSelected}
									/>
								</>
							)
						}
					}
				</MediaQuery>
			</div>

			{
				!isLargeScreen &&
				<EnhancedMenuBurger
					onClick={redirectTo}
					open={open}
					linkIsSelected={linkIsSelected}
				/>
			}
		</>
	)
}

export default Menu
